import api from './api';

/**
 * Obtiene la credencial SUNAT actual (si existe).
 * @returns {Promise<{ success: boolean, data?: { id: number, ruc: string, usuario_sol: string, has_password: boolean, created_at: string, updated_at: string } | null, message?: string }>}
 */
export async function getSunatCredentials() {
  const response = await api.get('/sunat-credentials');
  return response.data;
}

/**
 * Crea o actualiza la credencial SUNAT (singleton).
 * @param {{ ruc: string, usuario_sol: string, password_sol: string }} payload
 * @returns {Promise<{ success: boolean, data?: object, message?: string, errors?: object }>}
 */
export async function saveSunatCredentials(payload) {
  const response = await api.post('/sunat-credentials', payload);
  return response.data;
}

export default { getSunatCredentials, saveSunatCredentials };
